export const customButtonsTypes = ['bare']
